import React, {Component} from 'react'

import {
  Avatar,
  CardContent,
  Chip,
  Divider,
  Hidden,
} from 'material-ui'

import List, {ListItem,ListSubheader} from 'material-ui/List'

import UserChip from '../components/UserChip'

import {
  Accent,
  Primary,
} from '../helper/consts'

const style = {
  avatar:{
    backgroundColor:Primary,
  },
  referees:{
    display:'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
  },
  chip:{
    margin:'10px 0',
  },
  refereeUsers:{
    display:'flex',
    flexWrap: 'wrap'
  },
  span:{
    color:Accent,
    fontWeight:'500',
  },
  chipRow:{
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between',
    flexWrap:'wrap',
  },
  // row:{
  //   margin:'10px 0'
  // },
  to:{
    background: 'white',
    position: 'absolute',
    padding: '1px 9px',
  },
  line:{
    borderBottom: '3px double rgba(0,0,0,0.3)',
    flexGrow: '2',
    lineHeight: '0.1em',
    display: 'flex',
    justifyContent: 'center',
  }
}

export default class JobCardReferees extends Component{
  render(){
    // console.log(this.props);
    const {commission,uid,photoURL,displayName,users,applicantUID,applicantDisplayName,applicantPhotoURL} = this.props;
    console.log(this.props);
    const firstUser =
      users[0]===uid ?
        {uid,displayName,photoURL}
      :
        users[0]===applicantUID ?
          {uid:applicantUID,displayName:applicantDisplayName,photoURL:applicantPhotoURL}
        :
          {uid:users[0]}
    const lastUser = users[(users.length)-1]===uid?{uid,displayName,photoURL}:users[(users.length)-1]===applicantUID?{uid:applicantUID,displayName:applicantDisplayName,photoURL:applicantPhotoURL}:{uid:users[(users.length)-1]};
    console.log(lastUser);
    let {shareCount} = this.props;
    shareCount = shareCount || 0;
    let lowCommission=0;
    if(!!commission){lowCommission = commission/(shareCount+1)}
    return (
      <CardContent>
        {shareCount!=='hide' && shareCount!==null &&
          <List style={style.referees} subheader={<ListSubheader>Shared</ListSubheader>}>
            <ListItem className='jobCardRefereeListItem' style={style.chipRow}>
              <Chip avatar={<Avatar style={style.avatar} >{`${shareCount}`}</Avatar>} key='shares' label={`Share${shareCount===1?null:'s'}`} />
            </ListItem>
          </List>
        }
        <Divider light />
        {commission!==undefined && commission!==null &&
          <List style={style.referees} subheader={<ListSubheader>Commissions</ListSubheader>}>
            <ListItem className='jobCardRefereeListItem' style={style.chipRow}>
              {shareCount!==0?<Chip style={style.chip} avatar={<Avatar style={style.avatar} >$</Avatar>} key='lowCommission' label={`${lowCommission.toFixed(2)}`} />:null}
              {shareCount!==0?<Hidden xsDown ><span style={style.line}><span style={style.to}> to </span></span></Hidden>:null}
              {shareCount!==0?<Hidden smUp ><span> to </span></Hidden>:null}
              <Chip style={style.chip} avatar={<Avatar style={style.avatar} >$</Avatar>} key='commission' label={`$${commission.toFixed(2)}`} />
            </ListItem>
          </List>
        }
        <Divider light />
        <List style={style.referees} subheader={<ListSubheader>Referred</ListSubheader>}>
          <ListItem className='jobCardRefereeListItem' style={style.chipRow}>
            {users && users.length>0 && <UserChip key={`${users[0]}_first_user`} user={firstUser} style={style.chip} />}
            {users && users.length>1?<Hidden xsDown ><span style={style.line}><span style={style.to}>{` ${users.length - 2} `}</span></span></Hidden>:null}
            {users && users.length>1?<Hidden smUp ><span>{` ${users.length - 2} `}</span></Hidden>:null}
            {users && users.length>1?<UserChip key={`${users[0]}_last_user`} user={lastUser} style={style.chip} />:null}
          </ListItem>
        </List>
      </CardContent>
    )
  }
}

// {users && users.length>0?<Chip key={`${users[0]}_first_user`} avatar={users[0]===uid&&photoURL?<Avatar src={photoURL} />:users[0]===applicantUID?<Avatar src={applicantPhotoURL} />:null} style={style.chip} label={users[0]===uid&&displayName?displayName:users[0]===applicantUID?applicantDisplayName:users[0]} />:null}
// {users && users.length>1?<Chip key={`${users[0]}_last_user`} avatar={users[(users.length)-1]===uid&&photoURL?<Avatar src={photoURL} />:users[(users.length)-1]===applicantUID?<Avatar src={applicantPhotoURL} />:null} style={style.chip} label={users[(users.length)-1]===uid&&displayName?displayName:users[(users.length)-1]===applicantUID?applicantDisplayName:users[(users.length)-1]} />:null}



// WEBPACK FOOTER //
// ./src/components/JobCardReferees.js